import styled from 'styled-components'

import { HeaderLogo } from '@/components/Header/styles'

export const HeaderWrapper = styled.div`
  display: flex;
  padding-right: 60px;
  justify-content: space-between;
  & ${HeaderLogo} {
    width: 140px;
  }
`
